/// *** System import ***///
import { Component } from '@angular/core';
import { ViewController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../../../app/globals';
import { Account_PortfolioStore } from '../../portfolio.store';

@Component({
  selector: 'page-account-portfolio-sort',
  templateUrl: 'sort.html',
})
export class Account_PortfolioSortPopover {
  /// *** Data ***///
  private sortField: string;
  private isDescSort: boolean;
  constructor(
    // *** System
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    // *** Custom 
    private globals: Globals,
    private store: Account_PortfolioStore) {
    this.sortField = this.store.params.sortField;
    this.isDescSort = this.store.params.isDescSort;
  }

  // *** Fermer la fenêtre et retourner les paramètres de tri
  private _dismiss() {
    try {
      this.store.params.sortField = this.sortField;
      this.store.params.isDescSort = this.isDescSort;
      this.viewCtrl.dismiss();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.viewCtrl.dismiss();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/portfolio/popovers/sort/sort.ts